/**
 * 解决页面刷新后内容不可见的问题
 */

(function() {
    'use strict';

    // 任务1: 添加 'content-ready' 类以触发CSS透明度过渡
    function setContentReady() {
        if (document.body) {
            document.body.classList.add('content-ready');
        }
    }

    // 任务2: 模拟 resize 事件来修复布局
    function triggerResize() {
        // 创建一个新的 resize 事件
        const resizeEvent = new Event('resize');
        // 在 window 对象上派发这个事件
        window.dispatchEvent(resizeEvent);
    }

    // 任务3: 修复封面文字颜色，使其能双向切换
    function fixCoverTextColor() {
        const html = document.documentElement;
        const elements = document.querySelectorAll('#l_cover .title, #l_cover .subtitle, #l_cover .menu .list-h a p, #l_cover .menu .list-h a i, #l_cover .search-form .input');

        if (html.getAttribute('color-scheme') !== 'dark') {
            // 浅色模式: 强制设为深灰色
            elements.forEach(el => {
                if (el) {
                    el.style.setProperty('color', '#495057', 'important');
                    el.style.setProperty('text-shadow', 'none', 'important');
                }
            });
        } else {
            // 暗色模式: 移除我们添加的内联样式，恢复主题默认颜色（白色）
            elements.forEach(el => {
                if (el) {
                    el.style.removeProperty('color');
                    el.style.removeProperty('text-shadow');
                }
            });
        }
    }

    // 任务5: 持续监视并修复移动端所有区域的blur样式（PC端和移动端双向）
    function fixMobileBlurStyle() {
        const elementsToBlur = document.querySelectorAll('#l_side .widget, #l_main .widget, .l_main .widget, .post');
        if (!elementsToBlur || elementsToBlur.length === 0) {
            return;
        }

        if (window.innerWidth < 769) {
            // 移动端: 强制应用 blur 和半透明背景
            const isDarkMode = document.documentElement.getAttribute('color-scheme') === 'dark';
            const expectedBackground = isDarkMode ? 'rgba(45, 45, 45, 0.8)' : 'rgba(255, 255, 255, 0.8)';
            elementsToBlur.forEach(el => {
                el.style.setProperty('backdrop-filter', 'blur(20px)', 'important');
                el.style.setProperty('-webkit-backdrop-filter', 'blur(20px)', 'important');
                el.style.setProperty('background', expectedBackground, 'important');
            });
        } else {
            // PC端: 移除我们添加的内联样式，让CSS文件接管
            elementsToBlur.forEach(el => {
                el.style.removeProperty('backdrop-filter');
                el.style.removeProperty('-webkit-backdrop-filter');
                el.style.removeProperty('background');
            });
        }
    }

    // 组合执行
    function runFix() {
        setContentReady();
        fixCoverTextColor(); // 在显示内容的同时修复颜色
        fixMobileBlurStyle(); // 同时修复移动端blur样式
        // 延迟一点再触发 resize，给其他脚本一点反应时间
        setTimeout(triggerResize, 500);
    }

    // 在多个关键时间点执行我们的修复逻辑
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runFix);
    } else {
        runFix();
    }
    window.addEventListener('load', runFix);
    document.addEventListener('pjax:complete', runFix);

    // 任务4: 监听颜色模式切换，并实时修复
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'color-scheme') {
                // 当 color-scheme 属性变化时，重新运行颜色和blur修复函数
                fixCoverTextColor();
                fixMobileBlurStyle();
            }
        });
    });

    // 开始监视
    observer.observe(document.documentElement, {
        attributes: true // 只关心属性变化
    });

    // 持续运行blur修复函数，以应对窗口缩放等情况
    setInterval(fixMobileBlurStyle, 500);

})();

